import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
  static values = {
    open: Boolean,
  };

  toggle(e) {
    this.openValue = !this.openValue;
    e.currentTarget.setAttribute('aria-expanded', this.openValue);
  }
}